<template>
  <div
    id="sicredi-cookies-root"
    :data-dominioUUID="uuid"
    data-enviroment="PRD"
  />
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CookiesModuleComponent',

  data() {
    return {
      uuid: '',
    };
  },
  mounted() {
    this.loadCookiesModule();
    this.uuid = process.env.VUE_APP_UUID_COOKIES;
  },

  methods: {
    loadCookiesModule() {
      const scriptId = 'module-cookies-script';

      const scriptExists = document.querySelector(
        'script[src="https://web-static.sicredi.io/lgpd-consentimento-coleta-cookies-lib@1/static/js/main.js"]'
      );

      if (!scriptExists) {
        const script = document.createElement('script');
        script.id = scriptId;
        script.src =
          'https://web-static.sicredi.io/lgpd-consentimento-coleta-cookies-lib@1/static/js/main.js';
        script.async = true;

        document.body.appendChild(script);
      }
    },
  },
});
</script>
<style lang=""></style>
